import { COLOR_MAP } from '@utils/game/zenBlocks/constants.js';
export default {
  name: "MiniBlock",
  computed: {
    flatShape() {
      return this.shape.flatMap((row, r) => row.map((cell, c) => ({
        r,
        c,
        cell
      })));
    }
  },
  data() {
    return {
      COLOR_MAP
    };
  },
  props: {
    shape: {
      type: Array,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 20
    }
  }
};